import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import type { CustomFieldValueType } from '@vy/custom-fields-types';
import type { UpdateCustomer } from '@vy/types';

import { EditableCustomFieldValueCell } from '../../../../components/custom-fields/EditableCustomFieldValueCell';

type CustomerSettingsEditableCellProps = {
  index: number;
  valueType: CustomFieldValueType;
  allowedValues?: string[];
};

export const CustomerSettingsEditableCell: FC<CustomerSettingsEditableCellProps> = ({
  index,
  valueType,
  allowedValues,
}) => {
  const { control } = useFormContext<UpdateCustomer>();

  return (
    <Controller
      control={control}
      name={`customFieldValues.${index}.value`}
      render={({ field }) => (
        <EditableCustomFieldValueCell
          value={field.value}
          valueType={valueType}
          onCommit={field.onChange}
          onBlur={field.onBlur}
          dataVyPrefix={`customer-settings-custom-field-value-${index}`}
          allowedValues={allowedValues}
        />
      )}
    />
  );
};
